<template>
    <ModalBase
        name="addSancion"
        :title="'Nueva sanción para ' + abonado.name + ' ' + abonado.surnames"
        @close="close(false)"
    >
        <ValidationObserver tag="form" ref="observer" class="tw:flex tw:flex-col tw:gap-4" @submit.prevent="submit">
            <BaseDateInput label="Fecha de inicio" name="fecha_inicio" id="fecha_inicio" rules="required" :value="fecha_inicio" @input="fecha_inicio = $event" />
            <BaseDateInput label="Fecha de fin" name="fecha_fin" id="fecha_fin" rules="required" :value="fecha_fin" @input="fecha_fin = $event" />
            
            <div class="tw:flex tw:flex-col tw:gap-1">
                <label class="tw:text-xs tw:font-semibold tw:uppercase tw:tracking-wider tw:text-gray-500">Motivo</label>
                <QuillEditor v-model="motivo"/>
            </div>

            <label class="tw:flex tw:items-center tw:gap-2 tw:cursor-pointer">
                <input type="checkbox" v-model="bloquear_acceso" class="tw:appearance-auto tw:h-4 tw:w-4 tw:rounded tw:border-gray-300 tw:text-blue-600" />
                <span class="tw:text-sm tw:text-gray-700">Bloquear acceso</span>
            </label>

            <Button customClass="tw:justify-center" type="submit" :disabled="loading">Sancionar</Button>
        </ValidationObserver>
    </ModalBase>
</template>

<script setup>
    import { ref } from 'vue'
    import store from '@/store'
    import { useToast } from '@/composables/common/useToast'
    import { config } from '@/config'
    import ModalBase from '@/modules/admin/ui/ModalBase'
    import QuillEditor from "@/modules/ui/QuillEditor.vue"
    import BaseDateInput from '@/modules/admin/ui/BaseDateInput'
    import Button from '@/modules/admin/ui/Button.vue'

    const props = defineProps({
        abonado: Object
    })

    const emit = defineEmits(['close'])
    const toast = useToast()

    const fecha_inicio = ref(null)
    const fecha_fin = ref(null)
    const loading = ref(false)
    const bloquear_acceso = ref(0)
    const motivo = ref(null)
    const observer = ref(null)

    const close = (actualizar = false) => {
        emit('close', 'addSancion', actualizar)
    }

    const sancionar = () => {
        loading.value = true

        const bloqueFlag = bloquear_acceso.value ? 1 : 0

        const params = {
            id: props.abonado.id,
            fecha_inicio: fecha_inicio.value,
            fecha_fin: fecha_fin.value,
            abonado_id: props.abonado.id,
            bloquear_acceso: bloqueFlag,
            motivo: motivo.value
        }

        store.dispatch(config.getVuexAlias('back.abonados.sancionar'), params)
            .then(res => {
                const successMessage = res.data?.message || 'Sanción creada correctamente'
                toast.success(successMessage)
                close(true)
            })
            .catch(err => {
                const errorMessage = err.response?.data?.message || 'Error al crear la sanción'
                toast.error(errorMessage)
                close(false)
            })
            .finally(() => {
                loading.value = false
            })
    }

    const submit = async() => {
        const isValid = await observer.value.validate()
        if (isValid) {
            sancionar()
        }
    }
</script>
